export const TYPE = {
  material: 'material',
  questionnaire: 'questionnaire',
  exercise: 'exercise'
};

export const MATERIAL_TYPE = {
  image: 'common.type.image'
};
